<template>
  <SelectSimple
    v-if="selectedValue.length > 0"
    :inverted="inverted"
    :ariaLabel="'Select language'"
    v-model="selectedValue"
    :options="languageFormated"
    :smallArrow="small"
    :small="small"
    @change="onChange()"
  />
</template>
<script>
import Api from '@/Scripts/api/api';
import stringHelper from '@/Scripts/lib/helper/stringHelper.js';
const SelectSimple = () => import(/* webpackChunkName: "SelectSimple" */ '@/Scripts/components/shared/SelectSimple/SelectSimple.vue');

export default {
  components: {
    SelectSimple
  },
  props: {
    inverted: {
      type: Boolean,
      default: true
    },
    small: Boolean
  },
  computed: {
    languageFormated () {
      const arr = [];
      for (let i = 0; i < this.languages.length; i++) {
        arr.push({
          value: this.languages[i].Code,
          label: `${this.languages[i].Name}`
        });
      }
      return arr;
    }
  },
  methods: {
    getLanguages () {
      Api.get(
        `/api/language/GetContentLanguageUrls/?contentReferenceString=${document.body.getAttribute(
          'data-content-reference'
        )}`
      ).then(response => {
        this.languages = response.data.Languages;
        this.selectedValue = response.data.CurrentLanguage.Code;
      });
    },
    onChange: function (event) {
      this.languages.forEach(lang => {
        if (lang.Code === this.selectedValue) {
          location.href = stringHelper.updateUrlParameter(lang.Link, '', '');
        }
      });
    }
  },
  data: function () {
    return {
      languages: [],
      selectedValue: ''
    };
  },
  created () {
    this.getLanguages();
  }
};
</script>
